import React, { useState, useEffect, useContext } from "react";
import CompanyJob from "./CompanyJob";
import { Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import { AuthContext } from "../../context/AuthContext";
import { generateRandomString } from "../../Utility/Utility";
import moment from "moment";
import { useSnackbar } from "notistack";

export default function Profile(props) {
  const [companyDetail, setCompanyDetail] = useState([]);
  const [companyContact, setCompanyContact] = useState([]);
  const [companyService, setCompanyService] = useState([]);
  const [sameCompanyJobs, setSameCompanyJobs] = useState([]);
  const [companyJobs, setCompanyJobs] = useState([]);
  // const id = props.match.params.id;
  const clientslug = props.match.params.clientslug;
  const { enqueueSnackbar } = useSnackbar();
  const { isAuthenticated, userType } = useContext(AuthContext);
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    window.scrollTo(0, 0);
    axios
      .post("api/get_company_detail", { clientslug: clientslug }, { signal: controller.signal })
      .then((res) => {
        if (!isMounted) return; //Guard skip state if unmounted
        if (res.data.status == "success") {
          setCompanyDetail(res.data.data[0]);
          setCompanyContact(res.data.companycontact);
          setCompanyService(res.data.companyservice);
          setSameCompanyJobs(res.data.samecompanyjobs);
          setCompanyJobs(res.data.companyjobs);
        } else {
          setCompanyDetail([]);
          setCompanyContact([]);
          setCompanyService([]);
          setSameCompanyJobs([]);
          setCompanyJobs([]);
        }
      })
      .catch(error => {
          if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("Failed to load company details:", error);
        }
      });

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [clientslug]);

  return (
    <div className="section-full p-t120  p-b60 site-bg-light">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-12">
            <div className="cabdidate-de-info">
              <div className="twm-job-self-wrap">
                <div className="twm-job-self-info">
                  <div className="twm-job-self-top">
                    <div className="twm-media-bg">
                      {companyDetail.coverimgUrl ? (
                        <img
                          src={companyDetail.coverimgUrl}
                          alt={companyDetail.comp_name}
                        />
                      ) : (
                        <img
                          src="/default/default_company_logo.jpg"
                          alt={companyDetail.comp_name}
                        />
                      )}
                    </div>
                    <div className="twm-media">
                      {companyDetail.imgUrl ? (
                        <img
                          src={companyDetail.imgUrl}
                          alt={companyDetail.comp_name}
                        />
                      ) : (
                        <img
                          src="/default/default_company_logo.jpg"
                          alt={companyDetail.comp_name}
                        />
                      )}
                    </div>

                    <div class="company_name_dtl">
                      {companyDetail.comp_name != "" &&
                      companyDetail.display_profile == "Y" ? (
                        <Link to={`/company/${companyDetail.clientslug}`}>
                          {companyDetail.comp_name}
                        </Link>
                      ) : (
                        ""
                      )}
                      {companyDetail.comp_address != "" &&
                      companyDetail.display_orgaddress == "Y" ? (
                        <p class="twm-job-address">
                          <i class="ri-map-pin-line"></i>{" "}
                          {companyDetail.comp_address}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* <p>
                Xelwel Innovation (P.) Ltd. can help turn ideas into action.
                Providing technology solutions for over 5 years, Xelwel has been
                serving small, medium and big -sized businesses, institutions,
                and government agencies in and out of the Nepal. Like many
                service providers, Xelwel background and expertise is fully Web
                Application Development, Responsive Web Development, Mobile
                Application Development, Graphics Designing and Hardware and
                Networking Solution.
              </p> */}

              <div class="twm-job-self-mid-left">
                {companyDetail.industry != "" &&
                companyDetail.display_industry == "Y" ? (
                  <span class="twm-jobs-type site-text-primary">
                    <i class="ri-building-line"></i>
                    {companyDetail.industry}
                  </span>
                ) : (
                  ""
                )}
                {companyDetail.business != "" &&
                companyDetail.display_orgown == "Y" ? (
                  <span class="twm-job-websites site-text-primary">
                    <i class="ri-briefcase-line"></i> {companyDetail.business}
                  </span>
                ) : (
                  ""
                )}
                {companyDetail.orgsize != "" &&
                companyDetail.display_orgsize == "Y" ? (
                  <span class="twm-job-websites site-text-primary">
                    <i class="ri-user-2-fill"></i> {companyDetail.orgsize}
                  </span>
                ) : (
                  ""
                )}
                {companyDetail.mobile != "" &&
                companyDetail.display_number == "Y" ? (
                  <span class="twm-job-websites site-text-primary">
                    <i class="ri-cellphone-fill"></i> {companyDetail.mobile}
                  </span>
                ) : (
                  ""
                )}
                {companyDetail.comp_phone != "" &&
                companyDetail.display_number == "Y" ? (
                  <span class="twm-job-websites site-text-primary">
                    <i class="ri-phone-fill"></i> {companyDetail.comp_phone}
                  </span>
                ) : (
                  ""
                )}
                {companyDetail.comp_fax != "" &&
                companyDetail.display_fax == "Y" ? (
                  <span class="twm-jobs-amount  site-text-primary">
                    <i class="ri-message-2-fill"></i> Fax{" "}
                    {companyDetail.comp_fax}
                  </span>
                ) : (
                  ""
                )}
                {companyDetail.comp_pobox != "" &&
                companyDetail.display_fax == "Y" ? (
                  <span class="twm-job-websites site-text-primary">
                    <i class="ri-add-box-fill"></i> P.O. Box No.{" "}
                    {companyDetail.comp_pobox}
                  </span>
                ) : (
                  ""
                )}
                {companyDetail.email != "" &&
                companyDetail.display_email == "Y" ? (
                  <span class="twm-job-websites site-text-primary">
                    <i class="ri-mail-add-fill"></i> {companyDetail.email}
                  </span>
                ) : (
                  ""
                )}
                {companyDetail.comp_website != "" &&
                companyDetail.display_orgwebsite == "Y" ? (
                  <a href={companyDetail.comp_website} target="_blank">
                    <span class="twm-jobs-amount  site-text-primary">
                      <i class="ri-globe-fill"></i> {companyDetail.comp_website}
                    </span>
                  </a>
                ) : (
                  ""
                )}
                {companyDetail.viber != null &&
                companyDetail.display_orgsocial == "Y" ? (
                  <span class="twm-jobs-amount  site-text-primary">
                    <i class="ri-phone-fill"></i> {companyDetail.viber}
                  </span>
                ) : (
                  ""
                )}
                {companyDetail.whatsapp != null &&
                companyDetail.display_orgsocial == "Y" ? (
                  <span class="twm-jobs-amount  site-text-primary">
                    <i class="ri-whatsapp-fill"></i> {companyDetail.whatsapp}
                  </span>
                ) : (
                  ""
                )}
              </div>
              {companyDetail.description != "" &&
              companyDetail.display_orgsum == "Y" ? (
                <div>{ReactHtmlParser(companyDetail.description)}</div>
              ) : (
                ""
              )}
              {companyContact.length > 0 &&
              companyDetail.display_contperson == "Y" ? (
                <div class="educational-info">
                  <h4>
                    <i class="fa fa-users">&nbsp;</i> Contact Person
                  </h4>
                  {companyContact.length > 0
                    ? companyContact.map((contact, idx) => (
                        <div class="row pb-30">
                          <div class="col-md-3">
                            <h6>Contact Person - {idx + 1}</h6>
                          </div>
                          <div class="col-md-9">
                            <h5>
                              <i class="fa fa-user">&nbsp;</i> Name:{" "}
                              {contact.full_name}
                            </h5>
                            <p>
                              <i class="fa fa-id-card">&nbsp;</i> Designation:{" "}
                              {contact.position}
                            </p>
                            <p>
                              <i class="fa fa-envelope">&nbsp;</i> Email:{" "}
                              {contact.email}
                            </p>
                            <p>
                              <i class="fa fa-phone">&nbsp;</i> Phone:{" "}
                              {contact.phone}
                            </p>
                          </div>
                          <div class="clearfix"></div>
                        </div>
                      ))
                    : ""}
                </div>
              ) : (
                ""
              )}
              {companyService.length > 0 &&
              companyDetail.display_orgservice == "Y" ? (
                <div class="educational-info">
                  <h4>
                    <i class="fa fa-cogs">&nbsp;</i> Services
                  </h4>
                  {companyService.length > 0
                    ? companyService.map((service, idx) => (
                        <div class="row pb-30">
                          <div class="col-md-3">
                            <h6>Service - {idx + 1}</h6>
                          </div>
                          <div class="col-md-9">
                            <h5>
                              <i class="fa fa-cog">&nbsp;</i>{" "}
                              {service.service_name}
                            </h5>
                            {service.service_description}
                          </div>
                          <div class="clearfix"></div>
                        </div>
                      ))
                    : ""}
                </div>
              ) : (
                ""
              )}
              <div class="twm-social-tags">
                {companyDetail.facebook != null &&
                companyDetail.display_orgsocial == "Y" ? (
                  <a
                    href={companyDetail.facebook}
                    class="fb-clr"
                    target="_blank"
                  >
                    Facebook
                  </a>
                ) : (
                  ""
                )}
                {companyDetail.instagram != null &&
                companyDetail.display_orgsocial == "Y" ? (
                  <a
                    href={companyDetail.instagram}
                    class="fb-clr"
                    target="_blank"
                  >
                    Instagram
                  </a>
                ) : (
                  ""
                )}
                {companyDetail.linkedin != null &&
                companyDetail.display_orgsocial == "Y" ? (
                  <a
                    href={companyDetail.linkedin}
                    class="link-clr"
                    target="_blank"
                  >
                    Linkedin
                  </a>
                ) : (
                  ""
                )}
                {companyDetail.twitter != null &&
                companyDetail.display_orgsocial == "Y" ? (
                  <a
                    href={companyDetail.twitter}
                    class="tw-clr"
                    target="_blank"
                  >
                    Twitter
                  </a>
                ) : (
                  ""
                )}
                {companyDetail.youtube != null &&
                companyDetail.display_orgsocial == "Y" ? (
                  <a
                    href={companyDetail.youtube}
                    class="fb-clr"
                    target="_blank"
                  >
                    Youtube
                  </a>
                ) : (
                  ""
                )}
                {companyDetail.tiktok != null &&
                companyDetail.display_orgsocial == "Y" ? (
                  <a href={companyDetail.tiktok} class="fb-clr" target="_blank">
                    Tiktok
                  </a>
                ) : (
                  ""
                )}
                {/* <a href={companyDetail.viber} class="fb-clr" target="_blank">
                  Viber
                </a>
                <a
                  href={companyDetail.whatsapp}
                  class="whats-clr"
                  target="_blank"
                >
                  Whatsapp
                </a> */}
              </div>

              <h4 className="twm-s-title">Company Latest Vacancies</h4>

              <div className="twm-jobs-list-wrap">
                <ul>
                  {sameCompanyJobs.length > 0
                    ? sameCompanyJobs.map((sameCompanyJobs) => (
                        <CompanyJob
                          sameCompanyJobs={sameCompanyJobs}
                          key={sameCompanyJobs.id}
                        />
                      ))
                    : ""}

                  {/* <li>
                    <div className="twm-jobs-list-style1 mb-2">
                      <div className="twm-media">
                        <img src="assets/images/pic4.png" alt="Company Logo" />
                      </div>
                      <div className="twm-mid-content">
                        <a href="job-detail_v2.html" className="twm-job-title">
                          <h4 className="twm-job-title">
                            Senior Marketing Manager{" "}
                            <span className="twm-job-post-duration">
                              / 2 days ago
                            </span>
                          </h4>
                        </a>
                        <p className="twm-job-address">
                          Xelwel Innovation Pvt. Ltd.
                        </p>
                        <span className="twm-jobs-type site-text-primary">
                          <i className="ri-briefcase-line"></i> 2-4 Year
                        </span>
                        <span className="twm-job-websites site-text-primary">
                          <i className="ri-building-line"></i> Hybrid Work
                        </span>
                      </div>
                      <div className="twm-right-content">
                        <div className="twm-jobs-category green">
                          <span className="twm-bg-blue">Full Time</span>
                        </div>
                        <div className="twm-jobs-amount">
                          Rs.45-65 <small>thau</small> <span>/ Month</span>
                        </div>
                        <a
                          href="job-detail_v2.html"
                          className="twm-jobs-browse site-text-primary"
                        >
                          Browse Job
                        </a>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="twm-jobs-list-style1 mb-2">
                      <div className="twm-media">
                        <img src="assets/images/pic4.png" alt="Company Logo" />
                      </div>
                      <div className="twm-mid-content">
                        <a href="job-detail_v2.html" className="twm-job-title">
                          <h4 className="twm-job-title">
                            Door to Door Markeeting Representative{" "}
                            <span className="twm-job-post-duration">
                              / 5 days ago
                            </span>
                          </h4>
                        </a>
                        <p className="twm-job-address">
                          Xelwel Innovation Pvt. Ltd.
                        </p>
                        <span className="twm-jobs-type site-text-primary">
                          <i className="ri-briefcase-line"></i> 0-1 Year
                        </span>
                        <span className="twm-job-websites site-text-primary">
                          <i className="ri-building-line"></i> Hybrid Work
                        </span>
                      </div>
                      <div className="twm-right-content">
                        <div className="twm-jobs-category green">
                          <span className="twm-bg-sky">Freelancer</span>
                        </div>
                        <div className="twm-jobs-amount">
                          Rs.20-40 <small>thau</small> <span>/ Month</span>
                        </div>
                        <a
                          href="job-detail_v2.html"
                          className="twm-jobs-browse site-text-primary"
                        >
                          Browse Job
                        </a>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="twm-jobs-list-style1 mb-2">
                      <div className="twm-media">
                        <img src="assets/images/pic4.png" alt="Company Logo" />
                      </div>
                      <div className="twm-mid-content">
                        <a href="job-detail_v2.html" className="twm-job-title">
                          <h4 className="twm-job-title">
                            ISP Techinician{" "}
                            <span className="twm-job-post-duration">
                              / 10 days ago
                            </span>
                          </h4>
                        </a>
                        <p className="twm-job-address">
                          Xelwel Innovation Pvt. Ltd.
                        </p>
                        <span className="twm-jobs-type site-text-primary">
                          <i className="ri-briefcase-line"></i> 0-1 Year
                        </span>
                        <span className="twm-job-websites site-text-primary">
                          <i className="ri-building-line"></i> Hybrid Work
                        </span>
                      </div>
                      <div className="twm-right-content">
                        <div className="twm-jobs-category green">
                          <span className="twm-bg-gray">Internship</span>
                        </div>
                        <div className="twm-jobs-amount">
                          Rs.25-45 <small>thau</small> <span>/ Month</span>
                        </div>
                        <a
                          href="job-detail_v2.html"
                          className="twm-jobs-browse site-text-primary"
                        >
                          Browse Job
                        </a>
                      </div>
                    </div>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-4 col-md-12 rightSidebar">
            <h4 className="twm-s-title mt-0 text-center">
              Other Companies Jobs
            </h4>
            <div className="other_company_list">
              <ul>
                {companyJobs.length > 0
                  ? companyJobs.map((companyJobs) => (
                      <li>
                        <Link to={`/company/${companyJobs.clientslug}`}>
                          {companyJobs.imgUrl ? (
                            <img
                              src={companyJobs.imgUrl}
                              alt={companyJobs.comp_name}
                            />
                          ) : (
                            <img
                              src="/default/default_company_logo.jpg"
                              alt={companyJobs.comp_name}
                            />
                          )}
                          <span>{companyJobs.comp_name}</span>
                        </Link>
                      </li>
                    ))
                  : ""}
                {/* <li>
                  <a href="#">
                    <img
                      src="http://demo.naukari.com/default/default_company_logo.jpg"
                      alt="#"
                    />{" "}
                    <span>Tejobindu Solutions Pvt. Ltd.</span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img
                      src="http://demo.naukari.com/default/default_company_logo.jpg"
                      alt="#"
                    />{" "}
                    <span>Ekbana Solutions Pvt. Ltd.</span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img
                      src="http://demo.naukari.com/default/default_company_logo.jpg"
                      alt="#"
                    />{" "}
                    <span>Pravidhi Hub Pvt. Ltd.</span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img
                      src="http://demo.naukari.com/default/default_company_logo.jpg"
                      alt="#"
                    />{" "}
                    <span>Sabaiko Jobs Pvt. Ltd.</span>
                  </a>
                </li> */}
              </ul>
            </div>
            <div className="twm-advertisment">
              <div className="overlay"></div>
              <h4 className="twm-title">Recruiting?</h4>
              <p>
                Get Best Matched Jobs On your Email. <br />
                Add Resume NOW !{" "}
              </p>
              <Link to="/" className="site-button white">
                Read More
              </Link>
            </div>
            <div className="bigyapan">
              <Link to="/">
                <figure>
                  <img src="portal/images/interniship.png" alt="#" />
                </figure>
              </Link>
            </div>
          </div>
          <div className="clearfix"></div>
        </div>
      </div>
    </div>
  );
}
